
export default function Services() {
  const services = [
    {
      icon: 'ri-box-3-line',
      title: 'Handverpackung',
      description: 'Jedes Paket wird mit Liebe und Sorgfalt von Hand verpackt. Und trotzdem preisgünstig.',
      features: ['Persönliche Note', 'Qualitätskontrolle', 'Preisgünstig']
    },
    {
      icon: 'ri-truck-line',
      title: 'Versandabwicklung',
      description: 'Schnelle, tägliche und zuverlässige Versandabwicklung mit allen gängigen Versanddienstleistern. Ihre Kunden erhalten ihre Bestellungen pünktlich.',
      features: ['Alle Versandarten', 'Tracking-Service', 'Expressversand']
    },
    {
      icon: 'ri-store-3-line',
      title: 'Lagerung',
      description: 'Sichere Lagerung Ihrer Produkte in unseren historischen Lagerhallen. Optimale Bedingungen für alle Warenarten.',
      features: ['Klimakontrolle', 'Sicherheitssystem', 'Flexible Kapazitäten']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Kundenservice',
      description: 'Persönlicher Kundenservice, der Ihre Kunden begeistert. Wir behandeln jeden Auftrag wie unseren eigenen.',
      features: ['Persönliche Betreuung', 'Schnelle Reaktion', 'Individuelle Lösungen']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Unsere Leistungen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Von der Lagerung bis zum Versand - wir kümmern uns um Ihre Fulfillment-Bedürfnisse 
            mit der Sorgfalt und Liebe zum Detail, die Ihre Kunden verdienen.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow border border-gray-200">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-black`}></i>
              </div>
              <h3 className="text-xl font-bold text-black mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-black mr-2"></i>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
